import React from 'react'
import classnames from 'classnames'
import { Text } from '../../../..'

import styles from './StepTitle.module.scss'

export interface StepTitleProps {
  labelFor?: string
  children: React.ReactNode
  className?: string
}

const StepTitle = ({ labelFor, children, className }: StepTitleProps) => (
  <Text
    className={classnames(styles.text, className)}
    variant='neutralCool'
    variantCount='900'
    align='left'
    element={labelFor ? 'label' : 'h2'}
    size='l'
    weight='bold'
    htmlFor={labelFor}
  >
    {children}
  </Text>
)

export default StepTitle
